import moment from "moment";

/** Шаблон линии в подписях смены (voc_lines.templates / shift.templates). */
export function lineTemplateLabelRu(
  raw: string | null | undefined,
): string {
  if (raw == null || raw === "") return "—";
  const k = String(raw).toLowerCase();
  if (k === "atom") return "АТОМ";
  if (k === "vdp") return "ВДП";
  if (k === "custom") return "Общая";
  return String(raw);
}

function formatBeginTime(beginTime: unknown): string {
  if (beginTime == null || beginTime === "") return "";
  if (typeof beginTime === "string") {
    const t = beginTime.trim();
    if (/^\d{1,2}:\d{2}/.test(t)) return t.slice(0, 5);
    const m = moment(t, [moment.ISO_8601, "HH:mm:ss", "HH:mm"], true);
    if (m.isValid()) return m.format("HH:mm");
  }
  const m = moment(beginTime as any);
  return m.isValid() ? m.format("HH:mm") : "";
}

export type ShiftLabelRow = {
  shift_date?: unknown;
  times_of_day?: string | null;
  begin_time?: unknown;
  templates?: string | null;
};

/**
 * Текст для сохранения (shift_label) и отображения в комбобоксе смен.
 */
export function buildShiftLabel(row: ShiftLabelRow): string {
  const dateStr = row.shift_date
    ? moment(row.shift_date as any).format("DD.MM.YYYY")
    : "";
  const timeLabel =
    row.times_of_day === "day"
      ? "День"
      : row.times_of_day === "night"
        ? "Ночь"
        : row.times_of_day === "evening"
          ? "Вечер"
          : row.times_of_day || "";
  const beginStr = formatBeginTime(row.begin_time);
  const templateLabel = lineTemplateLabelRu(row.templates);
  return [dateStr, timeLabel, beginStr, templateLabel]
    .filter(Boolean)
    .join(" ");
}
